exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dialogue---19iU- div{line-height:15px}.footer-qtc---1OlZO{padding:16px 24px;flex-shrink:0;z-index:200;top:-20px;position:relative;background-color:#fff;border-radius:0 0 20px 20px;box-shadow:0 0 20px .821px rgba(11,55,83,.15);width:calc(100% - 40px);max-width:1200px}.footer-qtc---1OlZO .teacher-note-btn---YC677{background-color:#3477c7;height:48px;width:48px;overflow:hidden;outline:none}.footer-qtc---1OlZO .teacher-note-btn---YC677 img{width:30px;position:absolute}.footer-qtc---1OlZO .teacher-note-btn---YC677:hover{background-color:#fd7849}.footer-qtc---1OlZO .teacher-note-btn---YC677:focus-visible{outline:3px solid #3477c7;outline-offset:2px}", ""]);

// exports
exports.locals = {
	"dialogue": "dialogue---19iU-",
	"footer-qtc": "footer-qtc---1OlZO",
	"teacher-note-btn": "teacher-note-btn---YC677"
};